import Component from "./PageTransactions.vue";
export default Component;
